import { render, staticRenderFns } from "./FundCenter.vue?vue&type=template&id=5c91e7be&"
import script from "./FundCenter.vue?vue&type=script&lang=js&"
export * from "./FundCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports